import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Newsletter from "../Widget/Newsletter";
import "./header.scss";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import Div from "../Div";

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ""
        } cs-sticky_header ${isSticky ? "cs-sticky_header_active" : ""}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Div className="cs-anamnese_btn">
                  <a 
                    href="https://api.whatsapp.com/send/?phone=5567992199121&text=Ol%C3%A1+gostaria+de+informa%C3%A7%C3%B5es+sobre+a+sess%C3%A3o+de+psicomotricidade&type=phone_number&app_absent=0"
                    className="cs-btn_anamnese"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    AGENDE UMA ANAMNESE
                  </a>
                </Div>
              </Div>

              <Div className="cs-main_header_center">
                <Link className="cs-site_branding" to="/">
                  <img src="/logotype-v2.png" alt="Logo" />
                </Link>
              </Div>

              <Div className="cs-main_header_right">
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <Div
        className={
          sideHeaderToggle ? "cs-side_header active" : "cs-side_header"
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to="/">
            <img src="/logotype-v2.png" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading">
              Você tem alguem em mente?
              <br /> Entre em contato conosco.
            </h2>
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title="Contato" withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <Newsletter title="Subscribe" placeholder="email@gmail.com" />
          </Div>
        </Div>
      </Div>
    </>
  );
}
